module.exports = __webpack_public_path__ + "static/media/patmang1.5c45a573.png";